import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCallsheet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.38462 14.5H2V0.5H14V9.83333M9.38462 14.5L14 9.83333M9.38462 14.5V9.83333H14M4.76923 4.23333H11.2308M4.76923 7.03333H11.2308M4.76923 9.83333H6.61538",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconCallsheet;
